import { cn } from '../../lib/cn.ts';

export interface SpinnerProps {
  /** Sizing and colour come from the caller; `size-3.5` is the default. */
  className?: string;
}

/**
 * The one small "something is happening" mark: a quiet ring in the current
 * text colour. It says nothing itself — the words beside it do — which is why
 * it is `aria-hidden` and carries no label of its own.
 */
export function Spinner({ className }: SpinnerProps) {
  return (
    <svg
      data-slot='spinner'
      className={cn('size-3.5 animate-spin', className)}
      viewBox='0 0 16 16'
      fill='none'
      aria-hidden='true'
    >
      <circle cx='8' cy='8' r='6.5' stroke='currentColor' strokeWidth='2' opacity='0.3' />
      <path
        d='M14.5 8a6.5 6.5 0 0 0-6.5-6.5'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
}
